export const TEST_ID = 'confirmModal';

export const ESCAPE_KEY = 'Escape';
